/**
 *## Insert card blocks in collection grid
 */
function collectionCardBlocks() {
  //Select elements
  const productGrid = document.querySelector("#product-grid");
  const productGridItems = Array.from(
    productGrid.querySelectorAll(".grid__item")
  );
  const cardsBlocksContainer = document.querySelector(
    "#collection-card-blocks"
  );
  const cardsBlocks = cardsBlocksContainer.querySelectorAll(".grid__item");

  const insertCardInGrid = () => {
    cardsBlocks.forEach((element) => {
      // Clone element
      const clonedElement = element.cloneNode(true);
      // Get position
      const { collectionCardPosition } = clonedElement.dataset;
      // Parse to int and subtract 1 to be zero based
      const parsedPosition = +collectionCardPosition - 1;
      // Get sibling element [Element at the position to be inserted]
      const siblingElement = productGridItems.at(parsedPosition);
      // Insert cloned element
      productGrid.insertBefore(clonedElement, siblingElement);
    });
  };

  // Guard clause
  if (!cardsBlocks.length) return;
  insertCardInGrid();
}

collectionCardBlocks();
